<pbc-filter-preset
  [filter]="reisekostenabrechnungen.preset$ | async"
  [filters]="reisekostenabrechnungen.presets$ | async"
  [name]="reisekostenabrechnungen.search$ | async"
  (select)="reisekostenabrechnungen.setFilter($event)"
  (save)="reisekostenabrechnungen.writeFilter($event)"
  (delete)="reisekostenabrechnungen.deleteFilter($event)"
></pbc-filter-preset>
